import {FormikProps} from 'formik';
import SelectOutlet from '../../../../components/selectOutlet';
import {IProductForm} from './productFormData';
import useGetCountries from '../../../../services/hookService/getCountries/useGetCountriesList';

interface IProps {
  form: FormikProps<IProductForm>;
}

const ProducingCountry = ({form}: IProps) => {
  const {countriesLists, isLoading} = useGetCountries();

  const Options = countriesLists?.map(country => ({
    label: country.name,
    value: country.id,
  }));

  return (
    <section>
      <p className="mb-2 color-gray-1 text-md">کشور تولیدکننده</p>

      {isLoading ? (
        <div className="h-[50px] w-full rounded-lg bg-gray-200 animate-pulse" />
      ) : (
        <SelectOutlet
          name="producingCountry"
          label=""
          value={form?.values.producingCountry!}
          options={Options || []}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            form.setFieldValue('producingCountry', e.target.value)
          }
        />
      )}
    </section>
  );
};

export default ProducingCountry;
